import { createSelector } from 'reselect'
import { UserConnectionResponse } from 'src/models/people.models'
import { UserListModel, UserListResponse } from 'src/models/user.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectMembersListResponsesFromState = (
  state: RootState,
): Record<string, UserListResponse> => state.data.members.listResponses

export const selectOwnersAndAdminsListResponsesFromState = (
  state: RootState,
): Record<string, UserListResponse> =>
  state.data.members.ownersAndAdminsListResponses

export const selectContactFromState = (
  state: RootState,
): UserConnectionResponse[] | undefined => state.data.members.contact

export const selectMembersListModelsFromState = createSelector(
  [selectMembersListResponsesFromState],
  (peopleListResponses) =>
    Object.values(peopleListResponses).reduce<
      Record<UserListResponse['id'], UserListModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new UserListModel(curr),
      }),
      {},
    ),
)

export const selectOwnersAndAdminsListModelsFromState = createSelector(
  [selectOwnersAndAdminsListResponsesFromState],
  (peopleListResponses) =>
    Object.values(peopleListResponses).reduce<
      Record<UserListResponse['id'], UserListModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new UserListModel(curr),
      }),
      {},
    ),
)
